"use client";
import { useEffect, ReactNode } from "react";

const Lonely = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const activeTitle = "EMA";
    const inactiveTitle = "EMA - Come back!";

    if (typeof window !== "undefined") {
      document.title = activeTitle;

      const handleBlur = () => {
        document.title = inactiveTitle;
      };

      const handleFocus = () => {
        document.title = activeTitle;
      };

      window.addEventListener("blur", handleBlur);
      window.addEventListener("focus", handleFocus);

      return () => {
        window.removeEventListener("blur", handleBlur);
        window.removeEventListener("focus", handleFocus);
      };
    }
  }, []);

  return <>{children}</>;
};

export default Lonely;
